module.exports = __webpack_public_path__ + "static/media/loaded_inactive.8174718e.svg";